/**
 * MyScript javascript library to facilitate the use of cloud handwriting recognition
 *
 * @module MyScript
 * @requires Q
 * @requires CryptoJS
 */
/*global MyScript:true */
MyScript = {};